import React from 'react';
import { Container } from 'react-bootstrap';
import Menu from '../Menu/Menu';

const Blog1 = () => {
    return (
        <div>
            <Menu></Menu>
            <Container>
                <h3>Blog is not ready yet</h3>
            </Container>
        </div>
    );
};

export default Blog1;